<script>
import axios from "axios";
import { throttle } from "lodash";
import TextInput from "../../../../Shared/TextInput.vue";
import TabLayout from "../../Shared/TabLayout.vue";

export default {
    name: "Verify",
    components: { TabLayout, TextInput },
    props: {
        page_title: String,
        subtitle: String,
        recovery_email: String,
        from_url: String,
        tab_name: String,
        errors: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                token: null,
                recovery_email: this.recovery_email,
            }),
            resend_token: {
                message: null,
                isError: false,
            },
            resendToken: throttle(() => this.handleResendToken(), 30000)
        }
    },
    mounted() {
        document.querySelector('head title').textContent = this.page_title;
    },
    methods: {
        submit() {
            this.form.put(
                this.route('nl.employeedashboard.settings.recovery-mail.update')
            )
        },
        async handleResendToken() {
            try {
                const route = this.route('nl.employeedashboard.settings.recovery-mail.resend-token', {
                    recovery_email: this.recovery_email,
                })

                const response = await axios.post(route)

                this.resend_token.message = response.data.message
                this.resend_token.isError = false

            } catch (err) {
                this.resend_token.message = Lang.get('generic.something_went_wrong')
                this.resend_token.isError = true
            }
        }
    }
}
</script>

<template>
    <TabLayout
        :title="page_title"
        :subtitle="subtitle"
        :tabName="tab_name"
        :hideMsg="true"
    >
        <p>
            <span v-html="Lang.get('employeedashboard::pages/settings/recovery/email-recovery.verify.description.before_link', {
                email: recovery_email,
            })" />
            <a href="#" @click="resendToken" class="font-poppins font-weight-light font-size-16 color-blue">
                {{ Lang.get('employeedashboard::pages/settings/recovery/email-recovery.verify.description.link') }}
            </a>
            <span> {{ Lang.get('employeedashboard::pages/settings/recovery/email-recovery.verify.description.after_link') }}</span>
        </p>
        <form @submit.prevent="submit">
            <div class="w-50">
                <text-input
                    id="token"
                    v-model="form.token"
                    type="text"
                    :label="Lang.get('employeedashboard::pages/settings/recovery/email-recovery.form.token.label')"
                    :error="errors.token"
                />
            </div>
            <div class="mt-2">
                <a :disabled="form.processing"
                   :href="from_url"
                   class="font-poppins font-weight-light font-size-16 color-blue"
                >
                    {{ Lang.get('employeedashboard::pages/settings/recovery/email-recovery.buttons.use_different_email') }}
                </a>
            </div>
            <button type="submit" class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4 mt-4">
                {{ Lang.get('employeedashboard::pages/settings/recovery/email-recovery.buttons.submit_verify') }}
            </button>
        </form>

        <div class="my-3 p-2 rounded"
             :class="resend_token.isError ? 'alert-danger' : 'alert-info'"
             v-show="resend_token.message">
            {{ resend_token.message }}
        </div>
    </TabLayout>
</template>
